import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import StyledBox from "../styled/styledBox";
import React from "react";

const WelcomeStepFour = (): React.JSX.Element => (
  <StyledBox>
    <Typography variant="h5" color="initial" sx={{ mb: 2, fontWeight: "bold" }}>
      Schritt 4.
    </Typography>

    <Typography
      variant="body1"
      color="primary"
      sx={{ mb: 2, fontWeight: "bold" }}
    >
      Sichere deine Unterlagen und gib deinem Coach ein Feedback
    </Typography>

    <Typography variant="body1" color="initial" sx={{ mb: 2 }}>
      Nach dem Termin findest du die bearbeiteten Unterlagen unter{" "}
      <Link
        to={"/files"}
        style={{
          textAlign: "center",
          width: "100%",
          color: "inherit",
        }}
      >
        „Meine Unterlagen"
      </Link>
      .
    </Typography>

    <Typography variant="body1" color="initial" sx={{ mb: 2 }}>
      Nach dem Termin kannst du bei{" "}
      <Link
        to={"/appointments"}
        style={{
          textAlign: "center",
          width: "100%",
          color: "inherit",
        }}
      >
        „Meine Termine"
      </Link>{" "}
      dein Coaching bewerten.
    </Typography>
  </StyledBox>
);

export default WelcomeStepFour;
